import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "@arco-design/web-react";

import { useBreakpoint } from "../../utils/hooks/useBreakpoint";

interface IDeleteMeetingModalProps {
  onDeleteMeeting: () => void;
}

const DeleteMeetingModal = ({ onDeleteMeeting }: IDeleteMeetingModalProps) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  const { isMobile } = useBreakpoint('mobile');

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    onDeleteMeeting();
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <div>
      <Button
        className="meeting-card__button meeting-card__button-secondary"
        shape={"round"}
        size={isMobile ? "small" : "large"}
        onClick={showModal}
      >
        {t('common.delete_button')}
      </Button>

      <Modal
        title={t('admin.meetings.delete_meeting')}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={t('common.delete_button')}
        cancelText={t('common.cancel_button')}
        className="meeting-modal"
      >
        <p>{t('common.delete_meeting_confirmation_message')}</p>
      </Modal>
    </div>
  );
};

export default DeleteMeetingModal;
